import { labelComodidadePousada, labelComodidadeQuarto } from "@/lib/comodidades";

// Chips estáticos para listar comodidades.
// scope = "pousada" | "quarto"
export function ChipsComodidades({ items = [], scope = "pousada", className = "" }) {
  if (!Array.isArray(items) || items.length === 0) return null;
  const label = scope === "quarto" ? labelComodidadeQuarto : labelComodidadePousada;
  return (
    <ul
      data-testid={`chips-comodidades-${scope}`}
      className={`flex flex-wrap gap-2 ${className}`}
    >
      {items.map((slug) => (
        <li
          key={slug}
          className="px-3 py-1.5 rounded-full bg-[#083A6B]/8 border border-[#083A6B]/15 text-[12px] text-[#083A6B] font-medium"
        >
          {label(slug)}
        </li>
      ))}
    </ul>
  );
}
